module.exports = __webpack_public_path__ + "img/page.c58a80da.png";